import React from "react"
import { isEmpty } from "lodash"
import { useSelector } from "react-redux"
import { getTranslateByKey } from "./utils"

export function renderText(text: string | undefined | null): string {
  if (isEmpty(text)) return '-'

  return text
}
export const createResponsiveColGroup = (columnsByRow: number) => {
  const cols = Array(columnsByRow).fill(0).map((_, index) => {
    return <col key={index} style={{ width: `${100 / columnsByRow}%` }} />
  })
  return cols
}

export function getTranslateByKeySelector(key: string, isError?: boolean): string {
  const translate = useSelector((state: any) => state.translate)

  return getTranslateByKey(key, isError, translate)
}